<template>
  <div class="mf_card_bl questCard">
    <div>Vous pourrez entre autre et à tout moment :</div>
    <div class="mt-5">
      <ul>
        <li>Obtenir un diagnostic gratuit de votre portefeuille</li>
        <li>L’optimiser selon vos envies (réduire les frais et l’empreinte carbone de votre portefeuille, gérer votre risque, optimiser votre fiscalité...)</li>
        <li>Obtenir un suivi personnalisé de long terme en fonction des portefeuilles d’experts</li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style lang=""></style>
